import {MutationTree} from 'vuex'
import {initialState, SearchState} from '@/store/modules/search'
import {KeyValuePair} from '@payroll/optimus-common'

export const mutations: MutationTree<SearchState> = {

  setPortalTypes: (state, portalTypes: KeyValuePair[]) => {
    state.portalTypes = portalTypes
  },

  setUserTypes: (state, userTypes: KeyValuePair[]) => {
    state.userTypes = userTypes
  },

  resetState: (state) => {
    state = Object.assign(state, initialState())
  }
}
